import { ThemeProvider } from '@phonepe/enigma-ui';
import { ReactNode } from 'react';
import { Token } from '@shared/types';
import { useEnigmaThemeProvider } from './useEnigmaThemeProvider';
import { enigmaTokens } from '@shared/themes';

interface ThemeProviderProps {
	tokens?: Token;
	children: ReactNode;
}

const EnigmaThemeProvider: React.FC<ThemeProviderProps> = ({
	tokens = enigmaTokens,
	children,
}) => {
	const { mergedTokens } = useEnigmaThemeProvider(tokens);
	return <ThemeProvider tokens={mergedTokens}>{children}</ThemeProvider>;
};

export default EnigmaThemeProvider;
